/* import __COLOCATED_TEMPLATE__ from './sq-field-input-fractional-quantity.hbs.js'; */
/**
## Field input fractional quantity

`SqFieldInputFractionalQuantityComponent` is a variation of `SqInputFractionalQuantityComponent`, a text field input
that only accepts decimal numbers.

Like other `SqFieldInput` components, the input is technically standalone, but is
really intended to be nested inside a Form Field block component. The two components
communicate with each other over event handling and auto fill in placeholder if you don't add one.

```example
@title Example

@controller-properties
{
  maxIntegerLength: 10,
  placeholder: 'Placeholder',
  value: 20,
  actions: {
    onChange() {}
  }
}

@hbs
{{sq-field-input-fractional-quantity maxIntegerLength=maxIntegerLength
                                     placeholder=placeholder
                                     value=value
                                     onChange=(action "onChange")}}
```

@param {boolean} disabled - Boolean to disable input
@param {number} maxIntegerLength - Maximum integer length of input allowed
@param {string} placeholder - Placeholder value for the input box
@param {boolean} readonly - Boolean to make value read only
@param {object} value - Value object bound to this component
@param {action} onChange - Fired whenever value in input box changes

Sass dependencies at: `app/assets/stylesheets/bridgeport/components/form-elements/formfield/_formfield.sass`
*/

/* eslint square/no-restricted-files:"off" -- unscoped components in this folder are discouraged */
import FieldElementSupport from '@square/glass-ui/utils/field-element-support';
import SqInputFractionalQuantityComponent from '@dashboard/shared-ui/components/sq-input-fractional-quantity';
export default SqInputFractionalQuantityComponent.extend(FieldElementSupport);